import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { getAppLanguage } from "@fitness-app/data-models/entities/AppLanguage";

import { useTraineeSettings } from "~/modules/Trainee/TraineeProfile/scope";

export function TraineeLanguage({ traineeId }: { traineeId: string }) {
  const { t } = useTranslation("common");
  const { data: settings, isError } = useTraineeSettings();

  const language = settings?.id === traineeId ? getAppLanguage(settings.language) : null;

  return (
    <Typography.Text type="secondary">
      {t("language.label")}:{" "}
      {language ? t(`language.${language}`) : t(isError ? "language.loadError" : "language.loading")}
    </Typography.Text>
  );
}
